import { serverDropDestination, type ServerDropContext } from '../janus-engine/inventory/server-drop';
import type { InventoryMoveReceipt } from '../ft3d-move-handlers/inventory-move-receipt';

export type ProjectTransfer = (receipt: InventoryMoveReceipt) => unknown;
export type SettleServerDrop = (receipt: InventoryMoveReceipt, context: ServerDropContext, project: ProjectTransfer) => Promise<InventoryMoveReceipt>;

/** Keep the already drawn command across a reload/lost answer; a retry never rolls a second impact. */
export function serverDropCommand<T>(operationId: string, plan: () => T): T {
  const key = 'ft.server-drop.' + operationId;
  const saved = window.sessionStorage.getItem(key);
  if (saved) return JSON.parse(saved) as T;
  const command = plan();
  window.sessionStorage.setItem(key, JSON.stringify(command));
  return command;
}

/** Bundle bridge: one transfer projection and one awaited settlement, including overlapping/lost-answer retries. */
export function installServerDropBridge(settle: SettleServerDrop): void {
  const pending = new Map<string, Promise<InventoryMoveReceipt>>();
  Object.assign(window, { ftSettleServerInventoryDrop: (receipt: InventoryMoveReceipt, context: ServerDropContext, project: ProjectTransfer) => {
    const key = receipt.mutation_id.toUpperCase();
    const previous = pending.get(key);
    if (previous) return previous;
    if (!serverDropDestination(receipt, context.moveType)) { project(receipt); return Promise.resolve(receipt); }
    // Claim the id before running any callback (the receipt-applied event can synchronously re-enter).
    const task = Promise.resolve().then(() => settle(receipt, context, project));
    pending.set(key, task);
    return task;
  } });
}
